<template>
  <v-container fluid class="elozmenyek hirlista-oldal">
    <div class="top-icons w-100 pl-2">
      <v-btn
        icon
        large
        color="primary"
        class="back-btn"
        @click="$goBackTo({ name: 'Fooldal' })"
      >
        <i class="fas fa-chevron-left"></i>
      </v-btn>
      <k-hamburger-icon
        class="back-btn ml-auto"
        v-if="isMobile"
      ></k-hamburger-icon>
    </div>
    <div class="page-content pt-12">
      <h2>Előzmények</h2>
      <k-hir-lista :getHirek="GetHirek()" :headerHeight="120" isElozmeny>
        <k-nodata-info>
          <template v-slot:icon>
            <i class="fas fa-clipboard-list"></i>
          </template>
          <template v-slot:text>
            {{ nyelvesites['nincs_cikk_elozmeny_text'] }}
          </template>
        </k-nodata-info>
      </k-hir-lista>
      <img
        v-if="isBv"
        src="../assets/images/bv-logo-zold.png"
        class="bv-logo-green"
      />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { hirService } from '../services/HirService';
import settings from '../settings';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'Elozmenyek',
  data() {
    return {
      tab: null,
      isBv: settings.env == 'bv',
    };
  },
  mounted() {},
  created() {},
  methods: {
    GetHirek(kategoriaId) {
      return utolsoHir => {
        return hirService.GetAltalamOlvasottHirek({
          kategoriaId: kategoriaId,
          utolsoHirId: utolsoHir?.Id,
        });
      };
    },
  },
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  components: {},
};
</script>
